// src/firebase/config.js
// ─────────────────────────────────────────────────────────────────────────────
// Firebase konfigürasyonu. Gerçek değerleri Firebase Console'dan alın:
// https://console.firebase.google.com → Project Settings → Your apps
// ─────────────────────────────────────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC5Y9NrGUzOfaXQFzjJ-mTkNp8UAgOeTFM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "istanbulbistro.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "istanbulbistro",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "istanbulbistro.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "148183258237",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:148183258237:web:215d726e24af3a8a020d14",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;
